"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementEvaluationBatchV2Schema = exports.GroupedLogEntryInputSchema = exports.AssertionEvaluationResultV2Schema = exports.RequirementEvidenceInputSchema = void 0;
const zod_1 = require("zod");
const DesignObject_1 = require("../Requirements/types/DesignObject");
const continuity_key_1 = require("./continuity-key");
const enums_1 = require("./enums");
exports.RequirementEvidenceInputSchema = zod_1.z.object({
    kind: zod_1.z.string(),
    summary: zod_1.z.string(),
    payload: zod_1.z.unknown().optional(),
    rawPayloadRef: zod_1.z.string().optional(),
    contentHash: zod_1.z.string().optional(),
});
exports.AssertionEvaluationResultV2Schema = zod_1.z.object({
    assertionDefinitionId: zod_1.z.string(),
    resultSlug: zod_1.z.string(),
    continuityKey: continuity_key_1.ContinuityKeySchema.optional(),
    designObjects: DesignObject_1.DesignObjectSchema.array(),
    severity: enums_1.RequirementSeveritySchema,
    message: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    evidence: exports.RequirementEvidenceInputSchema.array().optional(),
    configurationSnapshot: zod_1.z.unknown().optional(),
    rawPayloadRef: zod_1.z.string().optional(),
    sourceResultKey: zod_1.z
        .string()
        .describe('Stable per-result key. Together with the batch-level `sourceSystem` and `sourceRunId`, anchors idempotency: a retry of the same logical write yields the same row.'),
});
exports.GroupedLogEntryInputSchema = zod_1.z.object({
    sourceSystem: zod_1.z.enum(['sigma-engine', 'ai-analysis', 'legacy-migration']),
    sourceRunId: zod_1.z.string(),
    sourceResultKey: zod_1.z
        .string()
        .describe('Per-log-entry idempotency anchor (e.g. "deterministic"). Together with (sourceSystem, sourceRunId) it identifies the single log entry that all of this batch\'s ARs link to.'),
    deterministicValidationPayload: zod_1.z.unknown().optional(),
    aiValidationPayload: zod_1.z.unknown().optional(),
    message: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
});
exports.RequirementEvaluationBatchV2Schema = zod_1.z.object({
    projectId: zod_1.z.string(),
    buildId: zod_1.z.string(),
    engineRunId: zod_1.z
        .string()
        .describe("The source system's run identifier — resolves to `sourceRunId` on each result row for idempotency."),
    sourceSystem: zod_1.z
        .enum(['sigma-engine', 'ai-analysis', 'legacy-migration'])
        .describe('Origin of the batch. Part of the source-key idempotency tuple (sourceSystem, sourceRunId, sourceResultKey).'),
    generatedAt: zod_1.z.string(),
    recordedAt: zod_1.z
        .string()
        .optional()
        .describe('When the recorded events occurred (ISO 8601). Stamped as the createdAt of the rows this batch creates; defaults to write time. The legacy migration sets it to the original analysis timestamp.'),
    assertionResults: exports.AssertionEvaluationResultV2Schema.array(),
    groupedLogEntry: exports.GroupedLogEntryInputSchema.optional(),
});
//# sourceMappingURL=RequirementEvaluationBatchV2.js.map